import { createId } from "@paralleldrive/cuid2";
import slugify from "@sindresorhus/slugify";
import { defaultResumeData, resumeDataSchema } from "@stylingcv/schema";
import type { ResumeData } from "@stylingcv/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import * as deepmergeModule from "deepmerge";

const deepmerge = (deepmergeModule as any).default ?? deepmergeModule;

/**
 * MCP / formatter output often omits empty sections. Merge with defaults so
 * resumeDataSchema validation succeeds on import (guest + authenticated).
 */
export function normalizeImportResumeData(data: unknown): ResumeData {
  const partial =
    data && typeof data === "object" && data !== null ? (data as Partial<ResumeData>) : {};
  const merged = deepmerge(defaultResumeData, partial, {
    arrayMerge: (_destination: unknown[], source: unknown[]) => source,
  });
  return resumeDataSchema.parse(merged);
}

export const importResumeSchema = z.object({
  title: z.string().optional(),
  slug: z
    .string()
    .min(1)
    .transform((value) => {
      const slug = slugify(value);
      if (slug === "") return createId();
      return slug;
    })
    .optional(),
  visibility: z.enum(["public", "private"]).default("private").optional(),
  data: z.unknown().transform((raw) => normalizeImportResumeData(raw)),
});

export class ImportResumeDto extends createZodDto(importResumeSchema) {}
